import { Flex, Text } from "@wayflyer/flyui";
import type { FundingApplicationSchemas } from "api-types";
import { FormattedMessage, useIntl } from "react-intl";
import { formatRevenueAmount, isInsufficientL60dRevenueAIR } from "shared-ui";

import { getRecievedPeriodString } from "../../utils";

export const PageDescription = ({
  airData,
}: {
  airData: FundingApplicationSchemas.AdditionalRevenueSourceAIRSchema;
}) => {
  const intl = useIntl();

  const meanMonthlyL60dRevenue = formatRevenueAmount(airData.mean_monthly_l60d_revenue, intl);
  const meanMonthlyL180dRevenue = formatRevenueAmount(airData.mean_monthly_l180d_revenue, intl);
  const thresholdMonthlyRevenue = formatRevenueAmount(airData.mean_30d_revenue_threshold, intl);
  const recievedPeriodString = getRecievedPeriodString(airData.missing_period, intl);

  if (
    airData.reasons.includes("insufficient_revenue_data") &&
    airData.reasons.includes("customer_revenue_not_sufficient_for_funding")
  ) {
    return (
      <Flex direction="column" gap="4">
        <FormattedMessage
          id="funding-application: revenue source description insufficient revenue and data"
          defaultMessage="<p>Wayflyer requires at least 6 months of eCommerce data to be able to fund you and we have only received {recievedPeriod} from your connected platforms.</p>"
          values={{
            p: (chunks: any) => <Text>{chunks}</Text>,
            recievedPeriod: recievedPeriodString,
          }}
        />
        <FormattedMessage
          id="funding-application: revenue source additional description customer_revenue_not_sufficient_for_funding"
          defaultMessage="<p>Additionally, we require an average monthly revenue of over {thresholdMonthlyRevenue} over the last {insufficientMonths} months for businesses in your region to access funding. After review of your data it appears that your business has an average monthly revenue of {meanMonthlyPeriodRevenue}.</p>"
          values={{
            p: (chunks: any) => <Text>{chunks}</Text>,
            thresholdMonthlyRevenue,
            insufficientMonths: isInsufficientL60dRevenueAIR(airData) ? 2 : 6,
            meanMonthlyPeriodRevenue: isInsufficientL60dRevenueAIR(airData)
              ? meanMonthlyL60dRevenue
              : meanMonthlyL180dRevenue,
          }}
        />
      </Flex>
    );
  }
  if (airData.reasons.includes("insufficient_revenue_data")) {
    return (
      <FormattedMessage
        id="funding-application: revenue source description insufficient_revenue_data"
        defaultMessage="<p>Wayflyer requires at least 6 months of eCommerce data to be able to fund you and we have only received {recievedPeriod} from your connected platforms.</p>"
        values={{
          p: (chunks: any) => <Text>{chunks}</Text>,
          recievedPeriod: recievedPeriodString,
        }}
      />
    );
  }
  if (airData.reasons.includes("customer_revenue_not_sufficient_for_funding")) {
    return (
      <FormattedMessage
        id="funding-application: revenue source description customer_revenue_not_sufficient_for_funding"
        defaultMessage="<p>Wayflyer requires an average monthly revenue of over {thresholdMonthlyRevenue} over the last {insufficientMonths} months for businesses in your region to access funding. After review of your data it appears that your business has an average monthly revenue of {meanMonthlyLDaysRevenue}.</p>"
        values={{
          p: (chunks: any) => <Text>{chunks}</Text>,
          thresholdMonthlyRevenue,
          insufficientMonths: isInsufficientL60dRevenueAIR(airData) ? 2 : 6,
          meanMonthlyLDaysRevenue: isInsufficientL60dRevenueAIR(airData)
            ? meanMonthlyL60dRevenue
            : meanMonthlyL180dRevenue,
        }}
      />
    );
  }
};
